import { createFileRoute } from "@tanstack/react-router";
import { MyCalendar } from "@/features/my-calendar/components/MyCalendar";

export const Route = createFileRoute("/calendar")({
  component: MyCalendar,
});
